$(function() {
    //IE11 Detection
    var IE11 = !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/));;
    if(IE11 === true){
        $('html').addClass('IE11');
    }

    $("#tabs > div").hide();
    $("#tabs > div:first").show();
    $("#tabs > span.tab-buttons button:first").addClass("active");
    $("#tabs > span.tab-buttons button").on("click", function () {
        $("#tabs > span.tab-buttons button").attr("class", "");
        $("#tabs > span.tab-buttons button").attr("tabindex", "-1");
        $("#tabs > span.tab-buttons button").attr("aria-selected", "false");
        $(this).attr("class", "active");
        $(this).attr("tabindex", "0");
        $(this).attr("aria-selected", "true");
        var currentTab = $(this).attr("aria-controls");
        $("#tabs > div").hide();
        $(`#${currentTab}`).show();
        return false;
    });
    $('.item-image, .slider').flexslider({
        animation: "slide",
        animationLoop: false,
        useCSS: false
    });
    if (document.body.classList.contains("pghome")) {
        function checkWidth() {
            var viewportWidth = document.documentElement.clientWidth;
            if (viewportWidth < 768) {
               
            } else {
               
            } 
        }
        checkWidth();
        window.addEventListener("resize", function(){
            checkWidth();
        });
    }
    // ADA AAA
    var $dropdowns = $("#main-nav .dropdown");
    var $dropdownsLinks = $("#main-nav .dropdownLink");
    $dropdownsLinks.on("focus",function(){
        let $thisParent = $(this).parent();
        $dropdowns.removeClass("open");
        $dropdownsLinks.attr("aria-expanded", "false");
        $thisParent.addClass("open");
        $(this).attr("aria-expanded", "true");
    })

    let fitstNavChild = $("#main-nav [role=menuitem]").first()[0];
    $(fitstNavChild).on("keydown", function(e) {
        if(e.key === 'Tab' && e.shiftKey) {
            $dropdowns.removeClass("open");
            $dropdownsLinks.attr("aria-expanded", "false");
        }
    })

    let lastNavChild = $("#main-nav [role=menuitem]").last()[0];
    $(lastNavChild).on("keydown", function(e) {
        if(e.key === 'Tab') {
            $dropdowns.removeClass("open");
            $dropdownsLinks.attr("aria-expanded", "false");
        }
    })

    function movePointsSection () {
        const elSectionPoints   = document.querySelector('.points');
        const elHpProduct       = [...document.querySelectorAll('.hp-product')].pop();
        const elMain            = document.querySelector('.main-hp');

        if (window.matchMedia("(max-width:660px)").matches) {
            elHpProduct.after(elSectionPoints)
        } else {
            elMain.after(elSectionPoints)
        }
    }

    if (document.body.classList.contains('pghome')) {
        movePointsSection();
        window.addEventListener('resize', movePointsSection);
    }

    function positionNav() {
        if(window.matchMedia("(min-width:1240px)").matches) {
            $('.header-inner .main-nav').insertBefore('.header-inner .utilities');
        }else if (window.matchMedia("(min-width:1024px)").matches){
            $('.header-inner .main-nav').insertAfter('.header-inner .utilities');
        }else {
            $('.header-inner .main-nav').insertBefore('.header-inner .main-logo');


        }
    }
    positionNav()
    window.addEventListener('resize', positionNav)
});

function videoHovering() {
    if (document.body.classList.contains("pghome")) {
        window.onload = function() { 
            const video = document.querySelector('.pillow-video-wrap video');
            video && video.addEventListener( 'mouseover', function(e) { 
                video.play();
            });
            video && video.addEventListener( 'mouseout', function(e) {
                video.pause();
            });
        };
    }
}

/* Video and Hero Cinemagraph Unprioritization*/
(function(a){(jQuery.browser=jQuery.browser||{}).mobile=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4));})(navigator.userAgent||navigator.vendor||window.opera);
if(!jQuery.browser.mobile) {
    setTimeout(function(){
        $("body.pghome #hp-video")
            .html("<video loop muted><source src='video/MAR-Pillow.mp4' type='video/mp4'><source src='video/MAR-Pillow.webm' type='video/webm'>");
        $("body.pghome #hero-cinema-gif")
            .html("<img src='images/cinemagraphs/bed-overlay.gif' alt='gif'>");
        videoHovering();
    }, 1500);
    
} else {
    $('#hp-video video').hide();
    $('#hero-cinema-gif img').hide();
}
